import { apiClient } from './apiClient';

export interface Appointment {
  id: string;
  doctorId: string;
  doctorName: string;
  doctorSpecialization?: string;
  serviceId: string;
  serviceName: string;
  date: string;
  time: string;
  status: 'scheduled' | 'completed' | 'cancelled' | 'rescheduled';
  notes?: string;
  memo?: string;
  memoImages?: string[];
  branchName?: string;
  branchAddress?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PreparationGuide {
  id: string;
  name: string;
  content: string;
}

export interface CancellationReason {
  id: string;
  name: string;
  requiresComment: boolean;
}

export interface AppointmentFilter {
  status?: 'scheduled' | 'completed' | 'cancelled';
  from?: string;
  to?: string;
}

export const appointmentService = {
  getAppointments: (filter?: AppointmentFilter) => {
    const params = new URLSearchParams();
    if (filter?.status) params.append('status', filter.status);
    if (filter?.from) params.append('from', filter.from);
    if (filter?.to) params.append('to', filter.to);

    const query = params.toString();
    const url = query ? `/webapp/appointments?${query}` : '/webapp/appointments';
    return apiClient.get<{ appointments: Appointment[] }>(url);
  },

  getAppointment: (id: string) =>
    apiClient.get<{ appointment: Appointment }>(`/webapp/appointments/${id}`),

  cancelAppointment: (id: string, comment: string, reasonId?: string) =>
    apiClient.post<{ success: boolean }>(`/webapp/appointments/${id}/cancel`, { comment, reasonId }),

  confirmAppointment: (id: string) =>
    apiClient.post<{ success: boolean }>(`/webapp/appointments/${id}/confirm`),

  getPreparationGuides: (appointmentId: string) =>
    apiClient.get<{ guides: PreparationGuide[] }>(`/webapp/appointments/${appointmentId}/preparation`),

  createRescheduleRequest: (appointmentId: string, description: string) =>
    apiClient.post<{ success: boolean }>(`/webapp/appointments/${appointmentId}/reschedule`, { description }),

  getCancellationReasons: () =>
    apiClient.get<{ reasons: CancellationReason[] }>('/webapp/appointments/cancellation-reasons'),
};

